const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence`;

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

const call = async (url, opts = {}) => {
  const res = await fetch(url, opts);
  const body = await res.json();
  if (!res.ok || body.error) {
    throw new Error(body.error || body.message || `Request failed (${res.status})`);
  }
  return body;
};

export const getRecommendations = (token) =>
  call(`${BASE}/restock/recommendations`, { headers: authHeaders(token) });

export const getRecommendationDetail = (token, sku) =>
  call(`${BASE}/restock/recommendation/${encodeURIComponent(sku)}`, { headers: authHeaders(token) });

export const setSkuPack = (token, sku, moq, pack_size) =>
  call(`${BASE}/inventory-health/sku-pack`, {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify({ sku, moq, pack_size }),
  });
